import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BuyPageComponent } from './buy.page.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { ProductDetailComponent } from '../product/productdetail/product.detail.component';

const routes: Routes = [
    {
        path: 'buy',
        component: BuyPageComponent,
        data: {
            breadcrumb: 'Search Products',
        },
        children: [
            {
                path: 'product/:sku',
                component: ProductDetailComponent,
                data: {
                    breadcrumb: 'sku',
                },
                children: [
                    {
                        path: 'bundledproduct/:sku',
                        component: ProductDetailComponent,
                        data: {
                            breadcrumb: 'sku'
                        }
                }]
            },
            {
                path: 'result/:searchparm',
                component: SearchResultComponent,
                data: {
                    breadcrumb: 'Result'
                },
                children: [
                    {
                        path: 'product/:sku',
                        component: ProductDetailComponent,
                        data: {
                            breadcrumb: 'sku'
                        },
                        children: [
                            {
                                path: 'bundledproduct/:sku',
                                component: ProductDetailComponent,
                                data: {
                                    breadcrumb: 'sku'
                                }
                            }]              // {
                        //     path: 'catalogue',
                        //     component: CatalogueComponent,
                        //     data: {
                        //         breadcrumb: 'Catalogue'
                        //     },
                        //     children: [
                        //         {
                        //             path: 'newsletter/:sku',
                        //             component: NewsletterComponent,
                        //         }
                        //     ]
                        // },
                        // {
                        //     path: 'catalogueedit',
                        //     component: CatalogueEditComponent,
                        //     data: {
                        //         breadcrumb: 'catalogueedit'
                        //     },
                        //     children: [
                        //         {
                        //             path: 'newsletter/:sku',
                        //             component: NewsletterComponent
                        //         },
                        //         {
                        //             path: 'editnewsletter/:sku',
                        //             component: EditNewsletterComponent
                        //         }
                        //     ]
                        // },
                    }]
            },

        ]
    },
    {
        path: 'search',
        redirectTo: '/buy',
        pathMatch: 'full'
    },
    {
        path: 'product/:sku',
        component: ProductDetailComponent,
        data: {
            breadcrumb: 'sku',
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BuyPageRoutingModule { }
